import React from "react";
import { Link, NavLink, Navigate, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, FileText, PenSquare, Settings, Inbox, ArrowRightLeft, LogOut, Trophy, ExternalLink, Search } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/posts", label: "Blog Posts", icon: PenSquare },
  { to: "/admin/pages", label: "Custom Pages", icon: FileText },
  { to: "/admin/submissions", label: "Submissions", icon: Inbox },
  { to: "/admin/settings", label: "Site & SEO", icon: Settings },
  { to: "/admin/redirects", label: "Redirects", icon: ArrowRightLeft },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-slate-300">Loading admin...</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;

  const onLogout = () => { logout(); navigate("/admin/login"); };

  return (
    <div className="min-h-screen bg-[#0a1226] text-white">
      <aside className="fixed left-0 top-0 bottom-0 w-64 bg-[#080f24] border-r border-white/5 hidden lg:flex lg:flex-col">
        <Link to="/admin" className="flex items-center gap-2.5 px-5 h-16 border-b border-white/5">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center"><Trophy className="w-4 h-4 text-[#0a1226]" /></div>
          <div>
            <div className="text-base font-extrabold">OnlineCricketID<span className="text-amber-400">.guru</span></div>
            <div className="text-[10px] text-slate-400 uppercase tracking-widest">Admin</div>
          </div>
        </Link>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${isActive ? "bg-amber-500/15 text-amber-300 border border-amber-500/30" : "text-slate-300 hover:bg-white/5"}`}
            >
              <n.icon className="w-4 h-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/5">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-2 px-3 py-2 text-xs text-slate-400 hover:text-amber-300"><ExternalLink className="w-3.5 h-3.5" /> View live site</a>
          <button onClick={onLogout} className="w-full mt-2 flex items-center gap-2 px-3 py-2 text-sm text-rose-300 hover:bg-rose-500/10 rounded-lg"><LogOut className="w-4 h-4" /> Logout</button>
        </div>
      </aside>
      <header className="lg:hidden sticky top-0 z-30 flex items-center justify-between px-4 h-14 bg-[#080f24] border-b border-white/5">
        <Link to="/admin" className="font-bold">OnlineCricketID Admin</Link>
        <button onClick={onLogout} className="text-rose-300 text-sm flex items-center gap-1"><LogOut className="w-4 h-4" /> Logout</button>
      </header>
      <main className="lg:pl-64">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 md:py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
